import React from "react";
import { default as Text } from "/application/webos/webos_tv_emulator/Text";
import { default as List } from "/application/webos/webos_tv_emulator/List";
import { default as Icons } from "/application/webos/webos_tv_emulator/Icons";
import { default as Image } from "/application/webos/webos_tv_emulator/Image";
import { default as SingleScreenList } from "/application/webos/webos_tv_emulator/SingleScreenList";
export default function Footer({
  myJSON,
  singleScreenStep,
  isSingleStepScreen,
  setIsSingleStepScreen,
  setSingleScreenStepLength,
}) {
  return (
    <div
      className="info-footer"
      style={{
        position: myJSON.position ? myJSON.position : null,
        bottom: myJSON.bottom ? myJSON.bottom : null,
        left: myJSON.top ? myJSON.top : null,
        margin: myJSON.margin ? myJSON.margin : "0 !important",
        transformOrigin: myJSON.transform_origin
          ? myJSON.transform_origin
          : "top left",
      }}
    >
      {myJSON.content.map((obj, i) => {
        switch (obj.component) {
          case "text":
            return <Text key={`footer${i}`} content={obj} isSingleStepScreen={isSingleStepScreen} singleScreenStep={singleScreenStep}/>;
          case "list":
            return <List key={`footer${i}`} content={obj} />;
          case "icons":
            return <Icons key={`footer${i}`} content={obj} />;
          case "image":
            return (
              <Image
                key={`footer${i}`}
                content={obj}
                singleScreenStep={singleScreenStep}
              />
            );
          case "single-screen-list":
            setIsSingleStepScreen(true);
            setSingleScreenStepLength(obj.content.length);
            return (
              <SingleScreenList
              key={`footer${i}`}
                content={obj}
                singleScreenStep={singleScreenStep}
                setIsSingleStepScreen={setIsSingleStepScreen}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
}
